import { plugin, Mode, useLightContext } from 'light-component';
import { Shoteyes } from 'zf-types';
import { useTranslation } from '../../../i18n';
import { WidgetType, WidgetKind } from '../types';
import { Thumbnail } from '../../component';
import { InputDesignMode } from './design';
import { InputInputMode } from './input';
import { InputViewMode } from './view';
import type { ReactElement } from 'react';
import type { InputProps } from './types';

export function Input(props: InputProps): ReactElement | null {
  const [t] = useTranslation();

  const { source } = useLightContext();
  // 是否是巡店模板
  const isShoteyesForm = source != null && (source as Shoteyes.Form).type === Shoteyes.FormType.CHECK;

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='InputIcon' title={t('Input')}
      toolTipContent={ isShoteyesForm ? t('较少字数文字记录，不影响报告分数') : t('较少字数文字记录')}
    />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<InputDesignMode {...props} initTitle={t('Input')} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<InputViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<InputInputMode {...props} />);
  }

  return null;
}

Input.prototype.type = WidgetType.INPUT;
plugin.register({ kind: WidgetKind.WIDGET, component: Input });
